'use strict';

angular.module('amexReconciliationApp')
  .factory('logoutInterceptor', function($q,$location,$window){
    return {
      'response':function(response){
        if (_.isString(response.data) && _.startsWith(response.data, '<!-- Login Page -->')) {
          $window.location.href = '/logout';
          return $q.reject(response);
        } else {
          return response;
        }
      }
    };
  }).config(['$httpProvider',function($httpProvider) {
    $httpProvider.interceptors.push('logoutInterceptor');
  }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/interceptors/logoutInterceptor.js
// module id = 565
// module chunks = 0